import { render, staticRenderFns } from "./SetPassWord.vue?vue&type=template&id=6d5b96ab&scoped=true&"
import script from "./SetPassWord.vue?vue&type=script&lang=js&"
export * from "./SetPassWord.vue?vue&type=script&lang=js&"
import style0 from "./SetPassWord.vue?vue&type=style&index=0&id=6d5b96ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5b96ab",
  null
  
)

export default component.exports